import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NgModule} from "@angular/core";

import {PopoverModule} from "ngx-popover";

import {CollapseMenuComponent} from "./collapse-menu/collapse-menu.component";
import {RecentProjectsComponent} from "./recent-projects/recent-projects.component";
import {FullScreenComponent} from "./full-screen/full-screen.component";

import {ActivitiesComponent} from "./activities/activities.component";
import {ActivitiesMessageComponent} from "./activities/activities-message/activities-message.component";
import {ActivitiesNotificationComponent} from "./activities/activities-notification/activities-notification.component";
import {ActivitiesTaskComponent} from "./activities/activities-task/activities-task.component";
import {HeaderComponent} from "./header.component";

import {UtilsModule} from "@app/shared/utils/utils.module";
import {PipesModule} from "@app/shared/pipes/pipes.module";
import {I18nModule} from "@app/shared/i18n/i18n.module";
import {UserModule} from "@app/shared/user/user.module";
import {BsDropdownModule, ModalModule, TabsModule} from "ngx-bootstrap";
import { RequestDealerComponent } from "./request-dealer/request-dealer.component";
import { BootstrapModule } from "@app/shared/bootstrap.module";
import { SmartadminInputModule } from "@app/shared/forms/input/smartadmin-input.module";
import { AgmCoreModule } from "@agm/core";
import { environment } from "@env/environment";
import { FileUploadModule } from '@app/file-upload/file-upload.module';
import { SmartadminWidgetsModule } from "@app/shared/widgets/smartadmin-widgets.module";
import { MomentModule } from "angular2-moment";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OpenCloseComponent } from "./open-close";




@NgModule({
  imports: [
    CommonModule,
    FileUploadModule,

    FormsModule,
    BootstrapModule,  //Activa modal
    
    SmartadminInputModule,
    SmartadminWidgetsModule,
    BsDropdownModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsKey
    }),
    UtilsModule,
    PipesModule, 
    I18nModule,
    MomentModule,
    UserModule, 
    NgbModule,
    PopoverModule,
    
  ],
  declarations: [
    ActivitiesMessageComponent,
    ActivitiesNotificationComponent,
    ActivitiesTaskComponent,
    RecentProjectsComponent,
    FullScreenComponent,
    CollapseMenuComponent,
    ActivitiesComponent,
    HeaderComponent,
    RequestDealerComponent,
    OpenCloseComponent
  ],
  exports: [
    HeaderComponent
    
  ]
})
export class HeaderModule{}
